import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '@/modules/core/app/constants/api.constants';
import { UploadImageResultObject } from '@/modules/announcement/models/UploadImageResultObject';

export class AnnouncementResource extends BaseResource {
  async markAsSeen(ids: number[]): Promise<void> {
    return this.postData(`${Route.ANNOUNCEMENTS_MARKASSEEN}`, { ids });
  }

  async uploadImage(image: Blob): Promise<UploadImageResultObject> {
    const formData: FormData = new FormData();
    formData.append('image', image);

    return this.postData(`${Route.ANNOUNCEMENTS_UPLOADIMAGE}`, formData);
  }
}

export default new AnnouncementResource();
